import React from "react";
import PropTypes from 'prop-types';

import styled, { keyframes } from "styled-components";
import COLORS from "@mlb/react-patterns/style/universal.color";
import IconPattern from "@mlb/react-patterns/components/Icon/icon";

const spin = keyframes`
    100% {
        transform: rotate(360deg);
    }
`;

const Icon = styled(IconPattern)`
    animation: ${spin} 2s linear infinite;
    margin: auto;
`;

const Spinner = ({
    iconName, width, fill,
}) => (
    <Icon
        name={iconName}
        width={width}
        fill={fill}
    />
);

Spinner.propTypes = {
    iconName: PropTypes.string,
    width: PropTypes.number,
    fill: PropTypes.string,

};

Spinner.defaultProps = {
    iconName: 'baseball',
    width: 132,
    fill: COLORS.mlbGrey5,
};

export default Spinner;